/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export interface IndexResponse {
  id: number;
  name: string;
  developer: {
    id: number;
    name: string;
  };
  apps: {
    id: number;
    appGroup: {
      id: number;
      name: string;
    };
    os: string;
    appId: string;
    dmpAppId: number;
    trackingVendor: {
      id: number;
      name: string;
    };
  }[];
  createdAt: string;
  updatedAt: string;
}

export type CreateParams = {
  developerId?: number;
  trackingVendorId?: number;
  name?: string;
  iosAppId?: string;
  androidAppId?: string;
  regexpCampaign?: string;
  regexpPubTwitter?: string;
};

export type UpdateParams = CreateParams;

export class Api {
  public static index() {
    return request.get<IndexResponse[]>("/admin/app_groups");
  }

  public static create(params: CreateParams) {
    return request.post("/admin/app_groups", params);
  }

  public static update(id: number, params: UpdateParams) {
    return request.post(`/admin/app_groups/${id}`, params);
  }
}
